<template>
	<div>
		<div v-if="active" id="content" class="app-content box-shadow-3">
			<div class="topbar">
				<div class="navbar theme-login bg box-shadow">
					<div>
						<a :href="`#/public/tasks/${refID}`" class="navbar-brand oscar-logo">
							<img :src="brand.logoHeader" alt="." class />
						</a>
					</div>
					<div v-if="!bankUser" class>
						<div class="btn btn-outline-light" v-on:click="goToLogin()">Login</div>
						<div class="btn btn-outline-light" v-on:click="goToRegister()">Create Account</div>
					</div>
					<div v-if="bankUser" class>
						<div class="mr-3">Welcome Back {{ bankUser.name }}</div>
						<div class="btn btn-outline-light" v-on:click="goToProfile()">Profile</div>
						<div class="btn btn-outline-light" v-on:click="Logout()">Logout</div>
					</div>
				</div>
				<section class="theme-login-light jumbotron text-center">
					<div class="container">
						<h1 class="jumbotron-heading">{{ taskbank.header_text }}</h1>
						<p v-html="taskbank.description" class="lead text-muted"></p>
					</div>
				</section>
			</div>
			<div class="container">
				<div class="container mainContainer">
					<div class="flex-row">
						<h6 class="flex mb-1 mr-1">
							<div class="col title">{{ assessment.name }}</div>
							<!-- <span class="col" v-if="assessment.ref_id">
              •
              <span class="text-muted text-sm">{{ assessment.ref_id }}</span>
              </span>-->
						</h6>
					</div>
					<div class="area col">
						<div class="labels">Grades :</div>
						<div class="grades">
							<span v-for="grade in assessment.grades" :key="grade.id" class="btn-info badge">
								{{ grade.name }}
							</span>
						</div>
					</div>
					<div class="area col">
						<div class="labels">{{ taskbank.field_names.standard }}s :</div>

						<span
							v-for="(standard, i) in assessment.standards"
							:key="i"
							class="btn-success badge theme-accent mr-1"
						>
							{{ standard }}
						</span>
					</div>
					<div class="area col">
						<div class="labels">{{ taskbank.field_names.essential_skill }}s :</div>

						<span v-if="assessment.essential_skills.length == 0" class="btn-warning badge theme-accent mr-1"
							>None</span
						>
						<span
							v-for="(eskill, i) in assessment.essential_skills"
							:key="i"
							class="btn-warning badge theme-accent mr-1"
						>
							{{ eskill }}
						</span>
					</div>
					<div class="area col">
						<div class="labels">{{ taskbank.field_names.content_area }}s :</div>

						<span v-if="assessment.content_area" class="btn-danger badge theme-accent mr-1">
							{{ assessment.content_area.name }}
						</span>
						<span
							v-for="(secondary_ca, i) in assessment.secondary_content_area_id"
							:key="i"
							class="btn-danger badge theme-accent mr-1"
						>
							<!-- {{
          getESName(secondary_ca)
              }}-->
						</span>
					</div>

					<div class="area col">
						<div class="labels">Description :</div>

						<span v-html="assessment.description" class="text-muted col"></span>
					</div>
					<div class="area resources col">
						<div class="labels">Resources :</div>
						<div v-for="resource in assessment.item.resources" v-bind:key="resource.id" class>
							-
							<span class="link" @click="viewResource(resource)">{{ resource.name }}</span>
							<a
								v-if="resource.mime_type == 'application/pdf'"
								@click="viewResourcePDF(resource)"
								class="far faw fa-eye"
								v-tippy
								title="Preview PDF File in Browser"
							></a>
						</div>
					</div>
				</div>
			</div>
			<div class="containter">
				<div class="comments container mainContainer">
					<div class="d-flex flex-row justify-content-between">
						<div class="title">Feedback :</div>

						<div v-if="!bankUser" class="text-muted">
							(You must
							<a class="login-link" :href="`#/public/register/${refID}`">create an account</a> and
							<a class="login-link" :href="`#/public/login/${refID}`">log in</a> to provide feedback.<br />Feedback will be seen by MCIEA staff only.)
						</div>
					</div>

					<div v-if="bankUser" class="d-flex flex-row add-comment-section mt-4 mb-4">
						<img class="img-fluid img-responsive rounded-circle mr-2" :src="brand.logoHeader" width="38" />
						<input type="text" class="form-control mr-3" placeholder="Add comment" v-model="comment" />
						<button class="btn btn-primary" type="button" @click="addComment()">Comment</button>
					</div>
					<hr />

					<div
						v-for="comment in comments"
						v-bind:key="comment.id"
						class="commented-section mt-2 card p-4 border border-secondary"
					>
						<div class="d-flex flex-row align-items-center commented-user">
							<h5 v-if="comment.user" class="mr-1 mb-0">{{ comment.user.name }}</h5>
							<h5 v-else class="mr-1 mb-0 text-muted">(Unknown user)</h5>
							<span v-if="comment.user && comment.user.district_id" class="btn-primary badge ml-2">
								{{ comment.user_district_name ? comment.user_district_name : "(Unknown district)" }}
							</span>
							<span class="ml-auto text-muted text-xxs">{{ fs.medDate(comment.created_at) }}</span>
						</div>
						<div class="comment-text-sm mt-2">
							<span>{{ comment.text }}</span>
						</div>
						<div class="reply-section">
							<!-- <div class="d-flex flex-row align-items-center voting-icons">
                <i class="fa fa-sort-up fa-2x mt-3 hit-voting"></i>
                <i class="fa fa-sort-down fa-2x mb-3 hit-voting"></i>
                <span class="ml-2">10</span>
                <span class="dot ml-2"></span>
              </div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="active" class="theme-login p-3 b-t mt-auto theme" v-html="taskbank.copyright"></div>
	</div>
</template>


<style scoped>
.margin-overlap {
	margin-right: -2.5rem;
}

.jumbotron {
	color: white;
	border-radius: 0px;
}
.left-section {
	background: #f4f3ef;
	padding: 1rem;
	border: 1px solid #ccc;
}
.right-section {
	padding-left: 50px;
}
div.inactive-page {
	padding-top: 500px;
	height: 10em;
	position: relative;
}
.taskLabel {
	display: inline-block;
	font-size: 0.875rem;
	font-family: "source_sans_prosemibold", Helvetica, Arial, sans-serif;
	color: #5f574f;
	text-transform: uppercase;
	margin: auto;
}
.mainContainer {
	border: 1px solid #ccc;
	padding: 10px;
}
.app-content {
	padding-bottom: 50px;
}
.box {
	border: 1px solid #ccc;

	padding: 5px;
	margin-left: 10px;
}
.inner {
	background-color: #fff;
}
.labels {
	font-family: "source_sans_prosemibold", Helvetica, Arial, sans-serif;
	color: #000;
	display: block;
	font-size: 12px;
	font-weight: bold;
	margin-bottom: 0.0625rem;
	text-transform: uppercase;
	padding-top: 5px;
}
.link {
	text-decoration: underline;
}
.link:hover {
	cursor: pointer;
	color: black;
}
.clickable:hover {
	cursor: pointer;
}
.comments {
	margin-top: 50px;
	margin-bottom: 50px;
}
.login-link {
	text-decoration: underline;
}
</style>

<script>
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import ResourceService from "@/services/ResourceService";
import ValidationService from "@/services/ValidationService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import Utils from "@/services/Utils";
import draggable from "vuedraggable";
import ConfigItemSearch from "@/components/ConfigItemSearch";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import BrandService from "@/services/BrandService";
import AssessmentService from "@/services/AssessmentService";
import TaskBankService from "@/services/TaskBankService";
import Router from "@/router";
import store from "@/services/Store";

var brand = BrandService.getBrand();

export default {
	name: "PublicAssessment",

	props: ["defaultTab", "valid", "user"],

	components: {
		EditPane,
		SaveOptionalModal,
	},

	data() {
		return {
			fs: fs,
			ntests: 0,
			originalDesc: [],
			refresh: null,
			assessment: {},
			brand: brand,
			dirty: false,
			taskID: this.$route.params.taskID,
			refID: "",
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {},
			eskills_text: "Essential Skills",
			standards_text: "Standards",
			taskbank: null,
			active: false,
			bankUser: null,
			comment: "",
			comments: [],
		};
	},

	computed: {},

	created() {
		this.assessment = {
			name: "this is then ame",
			ref_id: "test",
			description: "test description",
			grades: [{ id: "grade1" }],
			standards: ["st1", "st2"],
		};
		this.loadData();
		this.checkUser();
		this.LoadComments();
	},

	watch: {},

	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.saveOptNext = () => {
				next();
			};
			this.saveOptCancel = () => {
				next(false);
			};
			this.saveOptModal = true;
		} else {
			next();
		}
	},

	methods: {
		loadData() {
			AssessmentService.getPublicAssessment(this.taskID)
				.then((resp) => {
					this.assessment = resp.data.assessment;
					this.refID = resp.data.refID;
					if (this.refID == "CCE") {
						(this.eskills_text = "International Baccalaureate (IB) Standards"),
							(this.standards_text = "Massachusetts Standards");
					}
					this.loadTaskBankConfiguration();
					console.log(resp);
				})
				.catch((err) => {
					console.log(err);
					Notie.error("Failed to load Assessment", err);
				});
		},

		loadTaskBankConfiguration() {
			TaskBankService.getPublicTaskBank(this.refID)
				.then((resp) => {
					this.taskbank = resp.data;
					this.active = resp.data.active;
					if (resp.data.active == false) {
						this.$router.push("/");
					}
				})
				.catch((err) => {
					console.log(err);
					this.$router.push("/");
					// Notie.error("Failed to load public taskbank config", err);
				});
		},
		viewResourcePDF(resource) {
			console.log("view pdf");
			ResourceService.viewResourcePDF(this.assessment.id, resource);
		},
		viewResource(resource) {
			if (resource.type == 1) {
				ResourceService.viewPublicResource(this.assessment.id, resource);
			} else if (resource.type == 2) {
				ResourceService.viewExternalResource(resource.path);
			} else if (resource.type == 4) {
				ResourceService.viewExternalResource(resource.path);
			}
		},
		goBack() {
			this.$router.go(-1);
		},

		checkUser() {
			// check cookies
			let cookie = store.get(this, "bank_token");
			console.log("token found ", cookie);
			if (cookie) {
				TaskBankService.getBankUser(cookie.id)
					.then((resp) => {
						this.bankUser = resp.data;
						console.log(resp);
					})
					.catch((err) => {
						Notie.error(err);
					});
			}
		},
		goToLogin() {
			Router.push({ path: `/public/login/${this.refID}` });
		},
		goToRegister() {
			Router.push({ path: `/public/register/${this.refID}` });
		},
		goToProfile() {
			Router.push({ path: `/public/profile/${this.refID}` });
		},
		Logout() {
			let token = store.get(this, "bank_token");
			TaskBankService.bankLogout(token)
				.then((resp) => {
					this.bankUser = null;
					store.set(this, "bank_token", null);
					Router.push({ path: `/public/tasks/${this.refID}` });
				})
				.catch((err) => {
					Router.push({ path: `/public/tasks/${this.refID}` });

					Notie.error(err);
				});
		},
		LoadComments() {
			TaskBankService.GetTaskBankComments(this.taskID)
				.then((resp) => {
					this.comments = resp.data;
					console.log("Comments ", resp.data);
				})
				.catch((err) => {
					Notie.error(err);
				});
		},
		addComment() {
			let cmt = {
				text: this.comment,
				user_id: this.bankUser.id,
				client_id: this.bankUser.client_id,
				task_id: this.taskID,
				score: 0,
				status: 0,
			};

			TaskBankService.SaveTaskBankComment(cmt)
				.then((resp) => {
					this.comment = "";
					Notie.success("Comment Recieved", "Your comment will appear once it is approved by a moderator");
					this.LoadComments();
				})
				.catch((err) => {
					console.log(err);
					Notie.error("Failed to post the comment", err);
				});
		},
		// getESName(content_area_id){
		//   const found = this.contentAreas.find(element => element.id == content_area_id);
		//   return found.name
		// },
	},
};
</script>



// WEBPACK FOOTER //
// src/vues/Scan/PublicAssessment.vue